export const RISK_LEVELS = ['致命', '严重', '中风险', '低风险'] as const;
export type RiskLevel = (typeof RISK_LEVELS)[number];
const RISK_ALIASES: Record<string, RiskLevel> = {
  '致命': '致命', fatal: '致命', critical: '致命', 'critical risk': '致命', p0: '致命',
  '严重': '严重', '严重风险': '严重', severe: '严重', major: '严重', '高风险': '严重', high: '严重', p1: '严重',
  '中风险': '中风险', '中等风险': '中风险', medium: '中风险', 'medium risk': '中风险', danger: '中风险', '危险': '中风险', '一般': '中风险', p2: '中风险',
  '低风险': '低风险', low: '低风险', 'low risk': '低风险', '风险可控': '低风险', 可控: '低风险', p3: '低风险',
};
export function normalizeRiskLevel(value: unknown, fallback: RiskLevel = '低风险'): RiskLevel {
  const raw=String(value ?? '').trim(); if (!raw) return fallback; return RISK_ALIASES[raw.toLowerCase()] ?? fallback;
}
/** Optional assessed values must never acquire a risk merely by rendering/exporting. */
export function normalizeOptionalRiskLevel(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw || raw === '—' || raw === '-') return '';
  return RISK_ALIASES[raw.toLowerCase()] ?? raw;
}
export function riskLevelRank(value: unknown): number {
  const raw = String(value ?? '').trim();
  // 空风险排最后，避免新建行默认被当成「低风险」挤到表中/表首
  if (!raw || raw === '—' || raw === '-') return 5;
  switch (normalizeRiskLevel(value)) {
    case '致命': return 0;
    case '严重': return 1;
    case '中风险': return 2;
    case '低风险': return 3;
    default: return 4;
  }
}
export function riskLevelClass(value: unknown): string {
  switch(normalizeRiskLevel(value)){case '致命':return 'risk-fatal';case '严重':return 'risk-serious';case '中风险':return 'risk-medium';case '低风险':return 'risk-low';default:return 'risk-unset';}
}
export function riskLevelToPriority(value: unknown): string {
  switch(normalizeRiskLevel(value)){case '致命':return 'P0';case '严重':return 'P1';case '中风险':return 'P2';case '低风险':return 'P3';}
}
export function priorityToRiskLevel(value: unknown): RiskLevel {
  const raw=String(value ?? '').trim().toUpperCase(); if(raw==='P0')return '致命';if(raw==='P1')return '严重';if(raw==='P2')return '中风险';if(raw==='P3')return '低风险';return normalizeRiskLevel(value);
}
export function sortRowsByRisk<T>(rows:T[],getRisk:(row:T)=>unknown):T[] {
 return rows.map((row,index)=>({row,index})).sort((a,b)=>riskLevelRank(getRisk(a.row))-riskLevelRank(getRisk(b.row))||a.index-b.index).map(({row})=>row);
}
